import {FC} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Box} from '@chakra-ui/react';
import {useMessagesStore} from 'stores';
import {useT} from '@kcast-fe/core';

const ListHeaderFC: FC = () => {
  const {hasMore} = useMessagesStore(useShallow((state) => state));

  const {t} = useT();

  return (
    <Box
      h={'45px'}
      pt={'24px'}
      textAlign={'center'}
      color={'{colors.textTertiary}'}
      fontSize={'14px'}
    >
      {hasMore ? t('labels.loading') : null}
    </Box>
  );
};

export const ListHeader = ListHeaderFC;
